// MUI
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { styles } from "components/styles";

// Constants
import CustomButton from "constants/CustomButton";

const FeedbackModal = (props) => {
  const { open, success, title, message, onConfirm } = props;
  const Icon = success ? CheckCircleOutlineIcon : CancelOutlinedIcon;
  const color = success ? "success.main" : "error.main";

  return (
    <Dialog open={open} maxWidth="sm">
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ color, fontSize: { xs: 120, md: 140 } }} />
      </Box>
      <DialogTitle sx={{ ...styles.typographyTitle, py: 0 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ ...styles.leftAlignedTypographyBody, my: 0, py: 1 }}>
        {message}
      </DialogContent>
      <DialogActions
        sx={{ alignItems: "center", justifyContent: "center", mb: 1 }}
      >
        <CustomButton label="OK" onClick={onConfirm} />
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
